import React from 'react';
import PDPMobilePlaceholder from '../PDPMobilePlaceholder';
import PDPDesktopPlaceholder from '../PDPDesktopPlaceholder';

const PDPPlaceholder = () => (
  <>
    <PDPMobilePlaceholder />
    <PDPDesktopPlaceholder />
  </>
);

export default PDPPlaceholder;
